import { TableCellExpanded } from '@ksyos/design-system';

export function renderEmptyCells(numberOfEmptyCells: number) {
    return Array.from({ length: numberOfEmptyCells }, (_, i) => <TableCellExpanded key={i} />);
}
